<template>
    <div class="container">
        <el-card class="box-card">
            <el-row>
                <el-col :span="6">
                    <p>营业中店铺数</p>
                    <p class="mt10">
                        <span class="red">{{ shopCount.finished_task }}</span>家
                    </p>
                </el-col>
                <el-col :span="6">
                    <p>开店中店铺数</p>
                    <p class="mt10">
                        <span class="red">{{ shopCount.unfinished_task }}</span>家
                    </p>
                </el-col>
                <el-col :span="6">
                    <p>今日订单数</p>
                    <p class="mt10">
                        <span class="red">{{summary.totalNumber || 0}}</span>单
                    </p>
                </el-col>
                <el-col :span="6">
                    <p>本月订单数</p>
                    <p class="mt10">
                        <span class="red">{{summary1.totalNumber || 0}}</span>单
                    </p>
                </el-col>
            </el-row>
        </el-card>
        <el-row class="pt20 pb20">
            <div>
                <el-popover
                    placement="right"
                    width="400"
                    trigger="click">
                    <div>
                        <p>为确保高效进件，请在进件前先让商户提供以下完整信息：</p>
                        <p>1.邮箱账号、银行卡信息（包括卡号、账户名、开户行名称、支行名称和支行所在区域）</p>
                        <p>2.营业执照照片（确保无水印、清晰）、身份证正反面照片（确保无水印、清晰）</p>
                        <p>3.门店信息（包括门店名称、所在区域和详细地址、门头照片、内景照片）</p>
                        <p>4.其他：店铺所在地租赁协议或产权证明、已经签署好的合作确认函照片</p>
                    </div>
                    <el-button type="primary" size="mini" slot="reference">进件说明</el-button>
                </el-popover>
            </div>
        </el-row>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="营业中店铺" name="1">
                <!--form-->
                <el-form size="mini" :inline="true" label-position="left" :model="queryForm" ref="queryForm">
                    <el-form-item label="店铺名称" prop="shop_id">
                        <el-select
                            v-model="queryForm.shop_id"
                            filterable
                            clearable
                            placeholder="请输入店铺">
                            <el-option
                                v-for="item in shops"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="店铺手机号" prop="mp">
                        <el-input v-model="queryForm.mp" placeholder="请输入手机号" maxlength="11"></el-input>
                    </el-form-item>
                    <!-- -1-未进件 0-审核中 1-分账中 2-审核失败 3、待激活 4、签约中 5、进件成功-->
                    <el-form-item label="进件状态" prop="audit_status">
                        <el-select v-model="queryForm.audit_status" placeholder="请选择">
                            <el-option label="未进件" value="-1"></el-option>
                            <el-option label="审核中" value="0"></el-option>
                            <el-option label="分账中" value="1"></el-option>
                            <el-option label="审核失败" value="2"></el-option>
                            <el-option label="待激活" value="3"></el-option>
                            <el-option label="签约中" value="4"></el-option>
                            <el-option label="进件成功" value="5"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="queryForm.page=1;fetchData()">搜索</el-button>
                        <el-button @click="resetForm('queryForm')">重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="line"></div>
                <!--table-->
                <el-table
                    v-loading="loading"
                    :data="tableData"
                    border
                    style="width: 100%">
                    <el-table-column
                        prop="shop_name"
                        label="店铺名称">
                    </el-table-column>
                    <el-table-column
                        prop="mp"
                        label="店铺手机号">
                    </el-table-column>
                    <el-table-column
                        prop="created_at"
                        label="合作时间">
                    </el-table-column>
                    <el-table-column
                        prop="remit_period"
                        label="打款周期">
                        <template slot-scope="scope">
                            <span v-if="scope.row.remit_period">T + {{scope.row.remit_period}}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <!-- -1-未进件 0-审核中 1-分账中 2-审核失败 3、待激活 4、签约中 5、进件成功-->
                    <el-table-column
                        prop="audit_status"
                        label="进件状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.audit_status == -1">未进件</span>
                            <span v-else-if="scope.row.audit_status == 1">分账中</span>
                            <span v-else-if="scope.row.audit_status == 2">审核失败</span>
                            <span v-else-if="scope.row.audit_status == 3">待激活</span>
                            <span v-else-if="scope.row.audit_status == 4">签约中</span>
                            <span v-else-if="scope.row.audit_status == 5">进件成功</span>
                            <span v-else>审核中</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop=""
                        label="操作"
                        width="">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.audit_status == -1" type="text" size="mini" @click="bindKq(scope.row)">进件</el-button>
                            <el-button v-else-if="scope.row.audit_status == 2" type="text" size="mini" @click="bindKq(scope.row)">修改</el-button>
                            <el-button v-else type="text" size="mini" @click="bindKq(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--pagination-->
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryForm.page"
                    :page-sizes="pageSizes"
                    :page-size="queryForm.page_size"
                    layout="total, sizes, prev, pager, next"
                    :total="total">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="开店中店铺" name="2">
                <el-table
                    v-loading="loading"
                    :data="tableData"
                    border
                    style="width: 100%">
                    <el-table-column
                        prop="shop_name"
                        label="店铺名称">
                    </el-table-column>
                    <el-table-column
                        prop="mp"
                        label="店铺手机号">
                    </el-table-column>
                    <el-table-column
                        prop="status_tip"
                        label="开店进度">
                    </el-table-column>
                </el-table>
                <!--pagination-->
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryForm.page"
                    :page-sizes="pageSizes"
                    :page-size="queryForm.page_size"
                    layout="total, sizes, prev, pager, next"
                    :total="total">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "shopInfo",
    data() {
        return {
            activeName: '1',
            queryForm: {
                account_id: localStorage.getItem('userId'),
                // type: 1,
                mp: '',
                audit_status: '',
                shop_id: '',
                page: 1,
                page_size: 10
            },
            shops: JSON.parse(localStorage.getItem('shops')),
            loading: false,
            tableData: [],
            total: 0,
            pageSizes: [10,20,30,40,50],
            shopCount: {},
            summary: {},
            summary1: []
        }
    },
    created() {
        this.fetchData();
        this.getShopCount();
        this.getSummary();
        this.getSummary('month');
    },
    methods: {
        fetchData() {
            this.loading = true;
            this.queryForm.type = this.activeName;
            this.$api.get(this.$apiUrl.saasShopInfo, this.queryForm,(res)=>{
                this.loading = false;
                this.tableData = res.data.list || [];
                this.total = res.data.total || 0;
            },(res)=>{
                this.$message.warning(res.message);
                this.loading = false;
            })
        },
        // 店铺数据
        getShopCount() {
            this.$api.get(this.$apiUrl.getShopCount, {type: this.$store.getters.type, account_id: localStorage.getItem('userId')},(res)=>{
                this.shopCount = res.data;
            })
        },
        // 订单数据
        getSummary(month) {
            let day = new Date();
            if(month){
                day.setDate(1);
            }
            let startDate = moment(day).format('YYYYMMDD');
            let endDate = moment(new Date()).format('YYYYMMDD');
            this.$apiJava.post(this.$apiUrl.financeTransactionBillSummary, {startDate: startDate,endDate: endDate},(res)=>{
                if(month){
                    this.summary1 = res.data;
                }else{
                    this.summary = res.data;
                }
            },null,'oc')
        },
        handleClick() {
            this.queryForm.page = 1;
            this.tableData = [];
            this.fetchData();
        },
        bindKq(item) {
            this.$router.push({path:`/saas/kq/bind/${item.commercial_id}/${item.shop_id}/${item.audit_status}`});
            localStorage.setItem('auditTips', item.audit_tips);
        },
        //切换每页显示条数操作
        handleSizeChange(val) {
            this.queryForm.page_size = val;
            this.fetchData();
        },
        //切换页码操作
        handleCurrentChange(val) {
            this.queryForm.page = val;
            this.fetchData();
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.queryForm.page = 1;
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// shopInfo.vue?000cadaa